'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

interface AuthPageGuardProps {
  children: React.ReactNode;
}

export default function AuthPageGuard({ children }: AuthPageGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // Don't redirect while loading
    if (isLoading) return;

    // If user is already logged in, redirect to dashboard
    if (isAuthenticated) {
      console.log('User is already logged in, redirecting to dashboard');
      router.replace('/dashboard');
      return;
    }
  }, [isAuthenticated, isLoading, router]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If user is authenticated, don't render the auth page
  if (isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
